import axiosInstance from './axios';
import { handleError } from './utils';

const endpoints = {
  work: '/reports/work',
  invoicing: '/reports/invoicing',
};

const reportService = {
  getWorkReport: async (params) => {
    try {
      const response = await axiosInstance.get(endpoints.work, { params });
      if (response.status !== 200) {
        throw new Error('Failed to fetch work report');
      }
      const data = response.data;
      return data || null;
    } catch (error) {
      handleError(error);
    }
  },
  getInvoicingReport: async (params) => {
    try {
      const response = await axiosInstance.get(endpoints.invoicing, { params });
      if (response.status !== 200) {
        throw new Error('Failed to fetch invoicing report');
      }
      const data = response.data;
      return data || null;
    } catch (error) {
      handleError(error);
    }
  },
};

export default reportService;
